// extracted by mini-css-extract-plugin
export default {"PFSIcon":"PFSIcon_PFSIcon__jCkaa"};